import { alwaysArray } from '../helpers/functional';

const valueReducer = (initialState, setActions, resetActions) => (state = initialState, action) => {
  if (alwaysArray(resetActions).includes(action.type)) return initialState;
  if (alwaysArray(setActions).includes(action.type)) {
    return action.payload !== undefined ? action.payload : initialState;
  }
  return state;
};

export default valueReducer;
